module.exports = __webpack_public_path__ + "static/media/beer_hero.260b81ba.png";